<page-heading
  [title]="'user.form.pageTitle' | translate"
  [description]="
    isNew ? ('user.form.descriptionNew' | translate) : ('user.form.descriptionEdit' | translate)
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-xs-12 col-lg-6">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'user.form.nameLabel' | translate }}</label>
              <input
                type="text"
                class="form-control"
                maxlength="255"
                formControlName="name"
                [placeholder]="'user.form.namePlaceholder' | translate"
                required
              />
              <field-error-component
                [field]="'name'"
                [label]="'user.form.nameFieldLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 col-xl-6 mb-3">
              <label class="form-label">{{ 'user.form.emailLabel' | translate }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="email"
                placeholder="exemplo@email.com"
                required
              />
              <field-error-component
                [field]="'email'"
                [label]="'user.form.emailFieldLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 col-xl-6 mb-3">
              <label class="form-label">{{ 'user.form.phoneLabel' | translate }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="phone"
                placeholder="(00) 00000-0000"
                [mask]="'(00) 00000-0000'"
                required
              />
              <field-error-component
                [field]="'phone'"
                [label]="'user.form.phoneFieldLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-xl-6 mb-3">
              <label class="form-label">{{ 'user.form.tinLabel' | translate }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="tin"
                placeholder="000.000.000-00"
                [mask]="'000.000.000-00'"
              />
              <field-error-component
                [field]="'tin'"
                [label]="'user.form.tinFieldLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 col-xl-6 mb-3 trend-datepicker flex-column align-items-start">
              <label class="form-label">{{ 'user.form.birthDateLabel' | translate }}</label>
              <div class="d-flex w-100">
                <input
                  class="w-100"
                  [matDatepicker]="picker"
                  formControlName="birthDate"
                  placeholder="00/00/0000"
                  (focus)="picker.open()"
                />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <h4 class="card-header">{{ 'user.form.permissionsHeader' | translate }}</h4>
        <div class="card-body">
          <div class="row">
            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="roleAdmin" checked data-switch="success" formControlName="roleAdmin" (change)="toogleRoles($event, 'ADMIN')" (keydown)="onKeydown($event, 'roleAdmin', 'ADMIN')"
              />
              <label for="roleAdmin">
                <span>{{ 'user.form.roleAdmin' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="roleSupervisor" checked data-switch="success" formControlName="roleSupervisor" (change)="toogleRoles($event, 'SUPERVISOR')" (keydown)="onKeydown($event, 'roleSupervisor', 'SUPERVISOR')"
              />
              <label for="roleSupervisor">
                <span>{{ 'user.form.roleSupervisor' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12">
              <input type="checkbox" id="roleAttendant" checked data-switch="success" formControlName="roleAttendant" (change)="toogleRoles($event, 'ATTENDANT')" (keydown)="onKeydown($event, 'roleAttendant', 'ATTENDANT')"/>
              <label for="roleAttendant">
                <span>{{ 'user.form.roleAttendant' | translate }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-lg-6">
      <div class="card">
        <h4 class="card-header">{{ 'user.form.imageHeader' | translate }}</h4>
        <div class="card-body">
          <div class="upload-area" [ngClass]="{'has-image': user.image}">
            @if (loadingSpinner$ | async) {
              <loading-component class="loading" diameter="20" />
            } @else {
              @if (!user.image) {
                <div class="placeholder-content" (click)="addImage()">
                  <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                  <p class="text-primary">{{ 'user.form.uploadClick' | translate }}</p>
                  <p class="text-muted">
                    {{ 'user.form.uploadHint' | translate }}
                  </p>
                </div>
              }
            }

            <div class="upload-area__image" [ngStyle]="
                (loadingSpinner$ | async) ? { filter: 'blur(5px)' } : {}
              ">
              @if (user.image) {
                <figure class="figure-img">
                  <img [src]="user.image" [alt]="('user.form.imageAltPrefix' | translate) + user.image" class="preview-img" (click)="$event.stopPropagation()" />
                </figure>
                @if(formGroup.get('name').value) {
                  <h2>{{ formGroup.get('name').value }}</h2>
                }
                <button class="btn btn-outline-danger" type="button"
                  (click)="removeMidia(); $event.stopPropagation()">
                  <i class="mdi mdi-trash-can-outline"></i>
                </button>
              }
            </div>

            <input #fileInputFile type="file" accept="image/jpeg, image/png" (change)="onSelectImagem($event)" />
          </div>
        </div>
      </div>

      <div class="card">
        <h4 class="card-header">{{ 'user.form.attendantRulesHeader' | translate }}</h4>
        <div class="card-body">
          <div class="row">
            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="viewFullHistory" checked data-switch="success" formControlName="viewFullHistory" (keydown)="handleEnterKey($event, 'viewFullHistory')" />
              <label for="viewFullHistory">
                <span>{{ 'user.form.viewFullHistory' | translate }}</span>
              </label>
            </div>

            <!--
              Deal visibility (SPEC-2026-08-crm-pipeline-deals-radar — RF-22).
              Off means the user sees only the deals they own, which also withholds
              deals with no owner (RF-24). Administrators and supervisors see every
              deal regardless of this switch (RF-26).
            -->
            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="viewAllDeals" checked data-switch="success" formControlName="viewAllDeals" (keydown)="handleEnterKey($event, 'viewAllDeals')" />
              <label for="viewAllDeals">
                <span>{{ 'user.form.viewAllDeals' | translate }}</span>
              </label>
              <span class="help-block d-block">
                <small class="text-muted">{{ 'user.form.viewAllDealsHelp' | translate }}</small>
              </span>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="addLeads" checked data-switch="success" formControlName="addLeads" (keydown)="handleEnterKey($event, 'addLeads')" />
              <label for="addLeads">
                <span>{{ 'user.form.addLeads' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="deleteMessage" checked data-switch="success" formControlName="deleteMessage" (keydown)="handleEnterKey($event, 'deleteMessage')"/>
              <label for="deleteMessage">
                <span>{{ 'user.form.deleteMessage' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="blockContact" checked data-switch="success" formControlName="blockContact" (keydown)="handleEnterKey($event, 'blockContact')"/>
              <label for="blockContact">
                <span>{{ 'user.form.blockContact' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="editMessage" checked data-switch="success" formControlName="editMessage" (keydown)="handleEnterKey($event, 'editMessage')" />
              <label for="editMessage">
                <span>{{ 'user.form.editMessage' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="signatureConversation" checked data-switch="success" formControlName="signatureConversation" (keydown)="handleEnterKey($event, 'signatureConversation')" />
              <label for="signatureConversation">
                <span>{{ 'user.form.signatureConversation' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="clientVisibilitys" checked data-switch="success" formControlName="clientVisibilitys" (keydown)="handleEnterKey($event, 'clientVisibilitys')" />
              <label for="clientVisibilitys">
                <span>{{ 'user.form.clientVisibilitys' | translate }}</span>
              </label>
            </div>
            <div class="custom-switch col-12 mb-3">
              <input
                type="checkbox"
                id="transferAttendances"
                checked
                data-switch="success"
                formControlName="transferAttendances"
                />
                <label for="transferAttendances">
                  <span>{{ 'user.form.transferAttendances' | translate }}</span>
                </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="viewContacts" checked data-switch="success" formControlName="viewContacts" (keydown)="handleEnterKey($event, 'viewContacts')"/>
              <label for="viewContacts">
                <span>{{ 'user.form.viewContacts' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="viewIntegrations" checked data-switch="success" formControlName="viewIntegrations" (keydown)="handleEnterKey($event, 'viewIntegrations')"/>
              <label for="viewIntegrations">
                <span>{{ 'user.form.viewIntegrations' | translate }}</span>
              </label>
            </div>

            <div class="custom-switch col-12 mb-3">
              <input type="checkbox" id="exportConversation" checked data-switch="success" formControlName="exportConversation" (keydown)="handleEnterKey($event, 'exportConversation')"/>
              <label for="exportConversation">
                <span>{{ 'user.form.exportConversation' | translate }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<hr class="mt-4"/>

<div class="row mt-4">
  <div class="col-12 gap-2 d-flex justify-content-end pb-4">
    @if (!isNew) {
      <button class="btn btn-outline-danger" [disabled]="!formGroup.valid || loading"
        (click)="deleteUser()">{{ 'user.form.deleteButton' | translate }}</button>
    }

    <button class="btn btn-outline-secondary" (click)="back()">{{ 'user.form.cancelButton' | translate }}</button>

    <button class="btn btn-success" [disabled]="!formGroup.valid || loading" (click)="save()">
      {{ !loading ? (isNew ? ('user.form.saveButton' | translate) : ('user.form.updateButton' | translate)) : "" }}
      @if (loading) {
        <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
      }
    </button>
  </div>
</div>
